import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { SchematicDataVM } from './schematic-view';

@Injectable()
export class SchematicViewService {
    constructor(private _http: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public GetSchematicDataForImplement(data: number): Observable<SchematicDataVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('implementId', data.toString());
        return this._http.get("Api/Implement/GetSchematicDataForImplement", { search: params }).share().map(
            (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
    }

 
}